const flags = {
  AU: {
    name: "Australia",
    code: "AU",
    emoji: "🇦🇺",
    unicode: "U+1F1E6 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
  },
  AC: {
    name: "Ascension Island",
    code: "AC",
    emoji: "🇦🇨",
    unicode: "U+1F1E6 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AC.svg",
  },
  AD: {
    name: "Andorra",
    code: "AD",
    emoji: "🇦🇩",
    unicode: "U+1F1E6 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AD.svg",
  },
  AE: {
    name: "United Arab Emirates",
    code: "AE",
    emoji: "🇦🇪",
    unicode: "U+1F1E6 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AE.svg",
  },
  AF: {
    name: "Afghanistan",
    code: "AF",
    emoji: "🇦🇫",
    unicode: "U+1F1E6 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AF.svg",
  },
  AG: {
    name: "Antigua & Barbuda",
    code: "AG",
    emoji: "🇦🇬",
    unicode: "U+1F1E6 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AG.svg",
  },
  AI: {
    name: "Anguilla",
    code: "AI",
    emoji: "🇦🇮",
    unicode: "U+1F1E6 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AI.svg",
  },
  AL: {
    name: "Albania",
    code: "AL",
    emoji: "🇦🇱",
    unicode: "U+1F1E6 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AL.svg",
  },
  AM: {
    name: "Armenia",
    code: "AM",
    emoji: "🇦🇲",
    unicode: "U+1F1E6 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AM.svg",
  },
  AO: {
    name: "Angola",
    code: "AO",
    emoji: "🇦🇴",
    unicode: "U+1F1E6 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AO.svg",
  },
  AR: {
    code: "AR",
    name: "Argentina",
    emoji: "🇦🇷",
    unicode: "U+1F1E6 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AR.svg",
  },
  AQ: {
    name: "Antarctica",
    code: "AQ",
    emoji: "🇦🇶",
    unicode: "U+1F1E6 U+1F1F6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AQ.svg",
  },

  AS: {
    name: "American Samoa",
    code: "AS",
    emoji: "🇦🇸",
    unicode: "U+1F1E6 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AS.svg",
  },
  AT: {
    name: "Austria",
    code: "AT",
    emoji: "🇦🇹",
    unicode: "U+1F1E6 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AT.svg",
  },

  AW: {
    name: "Aruba",
    code: "AW",
    emoji: "🇦🇼",
    unicode: "U+1F1E6 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AW.svg",
  },
  AX: {
    name: "Åland Islands",
    code: "AX",
    emoji: "🇦🇽",
    unicode: "U+1F1E6 U+1F1FD",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AX.svg",
  },
  AZ: {
    name: "Azerbaijan",
    code: "AZ",
    emoji: "🇦🇿",
    unicode: "U+1F1E6 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/AZ.svg",
  },
  BA: {
    name: "Bosnia & Herzegovina",
    code: "BA",
    emoji: "🇧🇦",
    unicode: "U+1F1E7 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BA.svg",
  },
  BB: {
    name: "Barbados",
    code: "BB",
    emoji: "🇧🇧",
    unicode: "U+1F1E7 U+1F1E7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BB.svg",
  },
  BD: {
    name: "Bangladesh",
    code: "BD",
    emoji: "🇧🇩",
    unicode: "U+1F1E7 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BD.svg",
  },
  BE: {
    name: "Belgium",
    code: "BE",
    emoji: "🇧🇪",
    unicode: "U+1F1E7 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BE.svg",
  },
  BF: {
    name: "Burkina Faso",
    code: "BF",
    emoji: "🇧🇫",
    unicode: "U+1F1E7 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BF.svg",
  },
  BG: {
    name: "Bulgaria",
    code: "BG",
    emoji: "🇧🇬",
    unicode: "U+1F1E7 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BG.svg",
  },
  BH: {
    name: "Bahrain",
    code: "BH",
    emoji: "🇧🇭",
    unicode: "U+1F1E7 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BH.svg",
  },
  BI: {
    name: "Burundi",
    code: "BI",
    emoji: "🇧🇮",
    unicode: "U+1F1E7 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BI.svg",
  },
  BJ: {
    name: "Benin",
    code: "BJ",
    emoji: "🇧🇯",
    unicode: "U+1F1E7 U+1F1EF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BJ.svg",
  },
  BL: {
    name: "St. Barthélemy",
    code: "BL",
    emoji: "🇧🇱",
    unicode: "U+1F1E7 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BL.svg",
  },
  BM: {
    name: "Bermuda",
    code: "BM",
    emoji: "🇧🇲",
    unicode: "U+1F1E7 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BM.svg",
  },
  BN: {
    name: "Brunei",
    code: "BN",
    emoji: "🇧🇳",
    unicode: "U+1F1E7 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BN.svg",
  },
  BO: {
    name: "Bolivia",
    code: "BO",
    emoji: "🇧🇴",
    unicode: "U+1F1E7 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BO.svg",
  },
  BQ: {
    name: "Caribbean Netherlands",
    code: "BQ",
    emoji: "🇧🇶",
    unicode: "U+1F1E7 U+1F1F6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BQ.svg",
  },
  BR: {
    name: "Brazil",
    code: "BR",
    emoji: "🇧🇷",
    unicode: "U+1F1E7 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BR.svg",
  },
  BS: {
    name: "Bahamas",
    code: "BS",
    emoji: "🇧🇸",
    unicode: "U+1F1E7 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BS.svg",
  },
  BT: {
    name: "Bhutan",
    code: "BT",
    emoji: "🇧🇹",
    unicode: "U+1F1E7 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BT.svg",
  },
  BV: {
    name: "Bouvet Island",
    code: "BV",
    emoji: "🇧🇻",
    unicode: "U+1F1E7 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BV.svg",
  },
  BW: {
    name: "Botswana",
    code: "BW",
    emoji: "🇧🇼",
    unicode: "U+1F1E7 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BW.svg",
  },
  BY: {
    name: "Belarus",
    code: "BY",
    emoji: "🇧🇾",
    unicode: "U+1F1E7 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BY.svg",
  },
  BZ: {
    name: "Belize",
    code: "BZ",
    emoji: "🇧🇿",
    unicode: "U+1F1E7 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/BZ.svg",
  },
  CA: {
    name: "Canada",
    code: "CA",
    emoji: "🇨🇦",
    unicode: "U+1F1E8 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CA.svg",
  },
  CC: {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    emoji: "🇨🇨",
    unicode: "U+1F1E8 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CC.svg",
  },
  CD: {
    name: "Congo - Kinshasa",
    code: "CD",
    emoji: "🇨🇩",
    unicode: "U+1F1E8 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CD.svg",
  },
  CF: {
    name: "Central African Republic",
    code: "CF",
    emoji: "🇨🇫",
    unicode: "U+1F1E8 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CF.svg",
  },
  CG: {
    name: "Congo - Brazzaville",
    code: "CG",
    emoji: "🇨🇬",
    unicode: "U+1F1E8 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CG.svg",
  },
  CH: {
    name: "Switzerland",
    code: "CH",
    emoji: "🇨🇭",
    unicode: "U+1F1E8 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CH.svg",
  },
  CI: {
    name: "Côte d’Ivoire",
    code: "CI",
    emoji: "🇨🇮",
    unicode: "U+1F1E8 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CI.svg",
  },
  CK: {
    name: "Cook Islands",
    code: "CK",
    emoji: "🇨🇰",
    unicode: "U+1F1E8 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CK.svg",
  },
  CL: {
    name: "Chile",
    code: "CL",
    emoji: "🇨🇱",
    unicode: "U+1F1E8 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CL.svg",
  },
  CM: {
    name: "Cameroon",
    code: "CM",
    emoji: "🇨🇲",
    unicode: "U+1F1E8 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CM.svg",
  },
  CN: {
    name: "China",
    code: "CN",
    emoji: "🇨🇳",
    unicode: "U+1F1E8 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CN.svg",
  },
  CO: {
    name: "Colombia",
    code: "CO",
    emoji: "🇨🇴",
    unicode: "U+1F1E8 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CO.svg",
  },
  CP: {
    name: "Clipperton Island",
    code: "CP",
    emoji: "🇨🇵",
    unicode: "U+1F1E8 U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CP.svg",
  },
  CR: {
    name: "Costa Rica",
    code: "CR",
    emoji: "🇨🇷",
    unicode: "U+1F1E8 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CR.svg",
  },
  CU: {
    name: "Cuba",
    code: "CU",
    emoji: "🇨🇺",
    unicode: "U+1F1E8 U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CU.svg",
  },
  CV: {
    name: "Cape Verde",
    code: "CV",
    emoji: "🇨🇻",
    unicode: "U+1F1E8 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CV.svg",
  },
  CW: {
    name: "Curaçao",
    code: "CW",
    emoji: "🇨🇼",
    unicode: "U+1F1E8 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CW.svg",
  },
  CX: {
    name: "Christmas Island",
    code: "CX",
    emoji: "🇨🇽",
    unicode: "U+1F1E8 U+1F1FD",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CX.svg",
  },
  CY: {
    name: "Cyprus",
    code: "CY",
    emoji: "🇨🇾",
    unicode: "U+1F1E8 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CY.svg",
  },
  CZ: {
    name: "Czechia",
    code: "CZ",
    emoji: "🇨🇿",
    unicode: "U+1F1E8 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/CZ.svg",
  },
  DE: {
    name: "Germany",
    code: "DE",
    emoji: "🇩🇪",
    unicode: "U+1F1E9 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DE.svg",
  },
  DG: {
    name: "Diego Garcia",
    code: "DG",
    emoji: "🇩🇬",
    unicode: "U+1F1E9 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DG.svg",
  },
  DJ: {
    name: "Djibouti",
    code: "DJ",
    emoji: "🇩🇯",
    unicode: "U+1F1E9 U+1F1EF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DJ.svg",
  },
  DK: {
    name: "Denmark",
    code: "DK",
    emoji: "🇩🇰",
    unicode: "U+1F1E9 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DK.svg",
  },
  DM: {
    name: "Dominica",
    code: "DM",
    emoji: "🇩🇲",
    unicode: "U+1F1E9 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DM.svg",
  },
  DO: {
    name: "Dominican Republic",
    code: "DO",
    emoji: "🇩🇴",
    unicode: "U+1F1E9 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DO.svg",
  },
  DZ: {
    name: "Algeria",
    code: "DZ",
    emoji: "🇩🇿",
    unicode: "U+1F1E9 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/DZ.svg",
  },
  EA: {
    name: "Ceuta & Melilla",
    code: "EA",
    emoji: "🇪🇦",
    unicode: "U+1F1EA U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EA.svg",
  },
  EC: {
    name: "Ecuador",
    code: "EC",
    emoji: "🇪🇨",
    unicode: "U+1F1EA U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EC.svg",
  },
  EE: {
    name: "Estonia",
    code: "EE",
    emoji: "🇪🇪",
    unicode: "U+1F1EA U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EE.svg",
  },
  EG: {
    name: "Egypt",
    code: "EG",
    emoji: "🇪🇬",
    unicode: "U+1F1EA U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EG.svg",
  },
  EH: {
    name: "Western Sahara",
    code: "EH",
    emoji: "🇪🇭",
    unicode: "U+1F1EA U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EH.svg",
  },
  ER: {
    name: "Eritrea",
    code: "ER",
    emoji: "🇪🇷",
    unicode: "U+1F1EA U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ER.svg",
  },
  ES: {
    name: "Spain",
    code: "ES",
    emoji: "🇪🇸",
    unicode: "U+1F1EA U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ES.svg",
  },
  ET: {
    name: "Ethiopia",
    code: "ET",
    emoji: "🇪🇹",
    unicode: "U+1F1EA U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ET.svg",
  },
  EU: {
    name: "European Union",
    code: "EU",
    emoji: "🇪🇺",
    unicode: "U+1F1EA U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/EU.svg",
  },
  FI: {
    name: "Finland",
    code: "FI",
    emoji: "🇫🇮",
    unicode: "U+1F1EB U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FI.svg",
  },
  FJ: {
    name: "Fiji",
    code: "FJ",
    emoji: "🇫🇯",
    unicode: "U+1F1EB U+1F1EF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FJ.svg",
  },
  FK: {
    name: "Falkland Islands",
    code: "FK",
    emoji: "🇫🇰",
    unicode: "U+1F1EB U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FK.svg",
  },
  FM: {
    name: "Micronesia",
    code: "FM",
    emoji: "🇫🇲",
    unicode: "U+1F1EB U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FM.svg",
  },
  FO: {
    name: "Faroe Islands",
    code: "FO",
    emoji: "🇫🇴",
    unicode: "U+1F1EB U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FO.svg",
  },
  FR: {
    code: "FR",
    name: "France",
    emoji: "🇫🇷",
    unicode: "U+1F1EB U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/FR.svg",
  },
  GA: {
    name: "Gabon",
    code: "GA",
    emoji: "🇬🇦",
    unicode: "U+1F1EC U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GA.svg",
  },
  GB: {
    name: "United Kingdom",
    code: "GB",
    emoji: "🇬🇧",
    unicode: "U+1F1EC U+1F1E7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GB.svg",
  },
  "GB-ENG": {
    name: "England",
    code: "GB-ENG",
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    unicode: "U+1F3F4 U+E0067 U+E0062 U+E0065 U+E006E U+E0067 U+E007F",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GB-ENG.svg",
  },
  GD: {
    name: "Grenada",
    code: "GD",
    emoji: "🇬🇩",
    unicode: "U+1F1EC U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GD.svg",
  },
  GE: {
    name: "Georgia",
    code: "GE",
    emoji: "🇬🇪",
    unicode: "U+1F1EC U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GE.svg",
  },
  GF: {
    name: "French Guiana",
    code: "GF",
    emoji: "🇬🇫",
    unicode: "U+1F1EC U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GF.svg",
  },
  GG: {
    name: "Guernsey",
    code: "GG",
    emoji: "🇬🇬",
    unicode: "U+1F1EC U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GG.svg",
  },
  GH: {
    name: "Ghana",
    code: "GH",
    emoji: "🇬🇭",
    unicode: "U+1F1EC U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GH.svg",
  },
  GI: {
    name: "Gibraltar",
    code: "GI",
    emoji: "🇬🇮",
    unicode: "U+1F1EC U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GI.svg",
  },
  GL: {
    name: "Greenland",
    code: "GL",
    emoji: "🇬🇱",
    unicode: "U+1F1EC U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GL.svg",
  },
  GM: {
    name: "Gambia",
    code: "GM",
    emoji: "🇬🇲",
    unicode: "U+1F1EC U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GM.svg",
  },
  GN: {
    name: "Guinea",
    code: "GN",
    emoji: "🇬🇳",
    unicode: "U+1F1EC U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GN.svg",
  },
  GP: {
    name: "Guadeloupe",
    code: "GP",
    emoji: "🇬🇵",
    unicode: "U+1F1EC U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GP.svg",
  },
  GQ: {
    name: "Equatorial Guinea",
    code: "GQ",
    emoji: "🇬🇶",
    unicode: "U+1F1EC U+1F1F6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GQ.svg",
  },
  GR: {
    name: "Greece",
    code: "GR",
    emoji: "🇬🇷",
    unicode: "U+1F1EC U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GR.svg",
  },
  GS: {
    name: "South Georgia & South Sandwich Islands",
    code: "GS",
    emoji: "🇬🇸",
    unicode: "U+1F1EC U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GS.svg",
  },
  GT: {
    name: "Guatemala",
    code: "GT",
    emoji: "🇬🇹",
    unicode: "U+1F1EC U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GT.svg",
  },
  GU: {
    name: "Guam",
    code: "GU",
    emoji: "🇬🇺",
    unicode: "U+1F1EC U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GU.svg",
  },
  GW: {
    name: "Guinea-Bissau",
    code: "GW",
    emoji: "🇬🇼",
    unicode: "U+1F1EC U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GW.svg",
  },
  GY: {
    name: "Guyana",
    code: "GY",
    emoji: "🇬🇾",
    unicode: "U+1F1EC U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GY.svg",
  },
  HK: {
    name: "Hong Kong SAR China",
    code: "HK",
    emoji: "🇭🇰",
    unicode: "U+1F1ED U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HK.svg",
  },
  HM: {
    name: "Heard & McDonald Islands",
    code: "HM",
    emoji: "🇭🇲",
    unicode: "U+1F1ED U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HM.svg",
  },
  HN: {
    name: "Honduras",
    code: "HN",
    emoji: "🇭🇳",
    unicode: "U+1F1ED U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HN.svg",
  },
  HR: {
    name: "Croatia",
    code: "HR",
    emoji: "🇭🇷",
    unicode: "U+1F1ED U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HR.svg",
  },
  HT: {
    name: "Haiti",
    code: "HT",
    emoji: "🇭🇹",
    unicode: "U+1F1ED U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HT.svg",
  },
  HU: {
    name: "Hungary",
    code: "HU",
    emoji: "🇭🇺",
    unicode: "U+1F1ED U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/HU.svg",
  },
  IC: {
    name: "Canary Islands",
    code: "IC",
    emoji: "🇮🇨",
    unicode: "U+1F1EE U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IC.svg",
  },
  ID: {
    name: "Indonesia",
    code: "ID",
    emoji: "🇮🇩",
    unicode: "U+1F1EE U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ID.svg",
  },
  IE: {
    name: "Ireland",
    code: "IE",
    emoji: "🇮🇪",
    unicode: "U+1F1EE U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IE.svg",
  },
  IL: {
    name: "Israel",
    code: "IL",
    emoji: "🇮🇱",
    unicode: "U+1F1EE U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IL.svg",
  },
  IM: {
    name: "Isle of Man",
    code: "IM",
    emoji: "🇮🇲",
    unicode: "U+1F1EE U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IM.svg",
  },
  IN: {
    name: "India",
    code: "IN",
    emoji: "🇮🇳",
    unicode: "U+1F1EE U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IN.svg",
  },
  IO: {
    name: "British Indian Ocean Territory",
    code: "IO",
    emoji: "🇮🇴",
    unicode: "U+1F1EE U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IO.svg",
  },
  IQ: {
    name: "Iraq",
    code: "IQ",
    emoji: "🇮🇶",
    unicode: "U+1F1EE U+1F1F6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IQ.svg",
  },
  IR: {
    name: "Iran",
    code: "IR",
    emoji: "🇮🇷",
    unicode: "U+1F1EE U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IR.svg",
  },
  IS: {
    name: "Iceland",
    code: "IS",
    emoji: "🇮🇸",
    unicode: "U+1F1EE U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IS.svg",
  },
  IT: {
    name: "Italy",
    code: "IT",
    emoji: "🇮🇹",
    unicode: "U+1F1EE U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/IT.svg",
  },
  JE: {
    name: "Jersey",
    code: "JE",
    emoji: "🇯🇪",
    unicode: "U+1F1EF U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/JE.svg",
  },
  JM: {
    name: "Jamaica",
    code: "JM",
    emoji: "🇯🇲",
    unicode: "U+1F1EF U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/JM.svg",
  },
  JO: {
    name: "Jordan",
    code: "JO",
    emoji: "🇯🇴",
    unicode: "U+1F1EF U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/JO.svg",
  },
  JP: {
    name: "Japan",
    code: "JP",
    emoji: "🇯🇵",
    unicode: "U+1F1EF U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/JP.svg",
  },
  KE: {
    name: "Kenya",
    code: "KE",
    emoji: "🇰🇪",
    unicode: "U+1F1F0 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KE.svg",
  },
  KG: {
    name: "Kyrgyzstan",
    code: "KG",
    emoji: "🇰🇬",
    unicode: "U+1F1F0 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KG.svg",
  },
  KH: {
    name: "Cambodia",
    code: "KH",
    emoji: "🇰🇭",
    unicode: "U+1F1F0 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KH.svg",
  },
  KI: {
    name: "Kiribati",
    code: "KI",
    emoji: "🇰🇮",
    unicode: "U+1F1F0 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KI.svg",
  },
  KM: {
    name: "Comoros",
    code: "KM",
    emoji: "🇰🇲",
    unicode: "U+1F1F0 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KM.svg",
  },
  KN: {
    name: "St. Kitts & Nevis",
    code: "KN",
    emoji: "🇰🇳",
    unicode: "U+1F1F0 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KN.svg",
  },
  KP: {
    name: "North Korea",
    code: "KP",
    emoji: "🇰🇵",
    unicode: "U+1F1F0 U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KP.svg",
  },
  KR: {
    name: "South Korea",
    code: "KR",
    emoji: "🇰🇷",
    unicode: "U+1F1F0 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KR.svg",
  },
  KW: {
    name: "Kuwait",
    code: "KW",
    emoji: "🇰🇼",
    unicode: "U+1F1F0 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KW.svg",
  },
  KY: {
    name: "Cayman Islands",
    code: "KY",
    emoji: "🇰🇾",
    unicode: "U+1F1F0 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KY.svg",
  },
  KZ: {
    name: "Kazakhstan",
    code: "KZ",
    emoji: "🇰🇿",
    unicode: "U+1F1F0 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/KZ.svg",
  },
  LA: {
    name: "Laos",
    code: "LA",
    emoji: "🇱🇦",
    unicode: "U+1F1F1 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LA.svg",
  },
  LB: {
    name: "Lebanon",
    code: "LB",
    emoji: "🇱🇧",
    unicode: "U+1F1F1 U+1F1E7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LB.svg",
  },
  LC: {
    name: "St. Lucia",
    code: "LC",
    emoji: "🇱🇨",
    unicode: "U+1F1F1 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LC.svg",
  },
  LI: {
    name: "Liechtenstein",
    code: "LI",
    emoji: "🇱🇮",
    unicode: "U+1F1F1 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LI.svg",
  },
  LK: {
    name: "Sri Lanka",
    code: "LK",
    emoji: "🇱🇰",
    unicode: "U+1F1F1 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LK.svg",
  },
  LR: {
    name: "Liberia",
    code: "LR",
    emoji: "🇱🇷",
    unicode: "U+1F1F1 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LR.svg",
  },
  LS: {
    name: "Lesotho",
    code: "LS",
    emoji: "🇱🇸",
    unicode: "U+1F1F1 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LS.svg",
  },
  LT: {
    name: "Lithuania",
    code: "LT",
    emoji: "🇱🇹",
    unicode: "U+1F1F1 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LT.svg",
  },
  LU: {
    name: "Luxembourg",
    code: "LU",
    emoji: "🇱🇺",
    unicode: "U+1F1F1 U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LU.svg",
  },
  LV: {
    name: "Latvia",
    code: "LV",
    emoji: "🇱🇻",
    unicode: "U+1F1F1 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LV.svg",
  },
  LY: {
    name: "Libya",
    code: "LY",
    emoji: "🇱🇾",
    unicode: "U+1F1F1 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/LY.svg",
  },
  MA: {
    name: "Morocco",
    code: "MA",
    emoji: "🇲🇦",
    unicode: "U+1F1F2 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MA.svg",
  },
  MC: {
    name: "Monaco",
    code: "MC",
    emoji: "🇲🇨",
    unicode: "U+1F1F2 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MC.svg",
  },
  MD: {
    name: "Moldova",
    code: "MD",
    emoji: "🇲🇩",
    unicode: "U+1F1F2 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MD.svg",
  },
  ME: {
    name: "Montenegro",
    code: "ME",
    emoji: "🇲🇪",
    unicode: "U+1F1F2 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ME.svg",
  },
  MF: {
    name: "St. Martin",
    code: "MF",
    emoji: "🇲🇫",
    unicode: "U+1F1F2 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MF.svg",
  },
  MG: {
    name: "Madagascar",
    code: "MG",
    emoji: "🇲🇬",
    unicode: "U+1F1F2 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MG.svg",
  },
  MH: {
    name: "Marshall Islands",
    code: "MH",
    emoji: "🇲🇭",
    unicode: "U+1F1F2 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MH.svg",
  },
  MK: {
    name: "North Macedonia",
    code: "MK",
    emoji: "🇲🇰",
    unicode: "U+1F1F2 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MK.svg",
  },
  ML: {
    name: "Mali",
    code: "ML",
    emoji: "🇲🇱",
    unicode: "U+1F1F2 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ML.svg",
  },
  MM: {
    name: "Myanmar (Burma)",
    code: "MM",
    emoji: "🇲🇲",
    unicode: "U+1F1F2 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MM.svg",
  },
  MN: {
    name: "Mongolia",
    code: "MN",
    emoji: "🇲🇳",
    unicode: "U+1F1F2 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MN.svg",
  },
  MO: {
    name: "Macao SAR China",
    code: "MO",
    emoji: "🇲🇴",
    unicode: "U+1F1F2 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MO.svg",
  },
  MP: {
    name: "Northern Mariana Islands",
    code: "MP",
    emoji: "🇲🇵",
    unicode: "U+1F1F2 U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MP.svg",
  },
  MQ: {
    name: "Martinique",
    code: "MQ",
    emoji: "🇲🇶",
    unicode: "U+1F1F2 U+1F1F6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MQ.svg",
  },
  MR: {
    name: "Mauritania",
    code: "MR",
    emoji: "🇲🇷",
    unicode: "U+1F1F2 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MR.svg",
  },
  MS: {
    name: "Montserrat",
    code: "MS",
    emoji: "🇲🇸",
    unicode: "U+1F1F2 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MS.svg",
  },
  MT: {
    name: "Malta",
    code: "MT",
    emoji: "🇲🇹",
    unicode: "U+1F1F2 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MT.svg",
  },
  MU: {
    name: "Mauritius",
    code: "MU",
    emoji: "🇲🇺",
    unicode: "U+1F1F2 U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MU.svg",
  },
  MV: {
    name: "Maldives",
    code: "MV",
    emoji: "🇲🇻",
    unicode: "U+1F1F2 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MV.svg",
  },
  MW: {
    name: "Malawi",
    code: "MW",
    emoji: "🇲🇼",
    unicode: "U+1F1F2 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MW.svg",
  },
  MX: {
    name: "Mexico",
    code: "MX",
    emoji: "🇲🇽",
    unicode: "U+1F1F2 U+1F1FD",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MX.svg",
  },
  MY: {
    name: "Malaysia",
    code: "MY",
    emoji: "🇲🇾",
    unicode: "U+1F1F2 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MY.svg",
  },
  MZ: {
    name: "Mozambique",
    code: "MZ",
    emoji: "🇲🇿",
    unicode: "U+1F1F2 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/MZ.svg",
  },
  NA: {
    name: "Namibia",
    code: "NA",
    emoji: "🇳🇦",
    unicode: "U+1F1F3 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NA.svg",
  },
  NC: {
    name: "New Caledonia",
    code: "NC",
    emoji: "🇳🇨",
    unicode: "U+1F1F3 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NC.svg",
  },
  NE: {
    name: "Niger",
    code: "NE",
    emoji: "🇳🇪",
    unicode: "U+1F1F3 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NE.svg",
  },
  NF: {
    name: "Norfolk Island",
    code: "NF",
    emoji: "🇳🇫",
    unicode: "U+1F1F3 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NF.svg",
  },
  NG: {
    name: "Nigeria",
    code: "NG",
    emoji: "🇳🇬",
    unicode: "U+1F1F3 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NG.svg",
  },
  NI: {
    name: "Nicaragua",
    code: "NI",
    emoji: "🇳🇮",
    unicode: "U+1F1F3 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NI.svg",
  },
  NL: {
    name: "Netherlands",
    code: "NL",
    emoji: "🇳🇱",
    unicode: "U+1F1F3 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NL.svg",
  },
  NO: {
    name: "Norway",
    code: "NO",
    emoji: "🇳🇴",
    unicode: "U+1F1F3 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NO.svg",
  },
  NP: {
    name: "Nepal",
    code: "NP",
    emoji: "🇳🇵",
    unicode: "U+1F1F3 U+1F1F5",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NP.svg",
  },
  NR: {
    name: "Nauru",
    code: "NR",
    emoji: "🇳🇷",
    unicode: "U+1F1F3 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NR.svg",
  },
  NU: {
    name: "Niue",
    code: "NU",
    emoji: "🇳🇺",
    unicode: "U+1F1F3 U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NU.svg",
  },
  NZ: {
    name: "New Zealand",
    code: "NZ",
    emoji: "🇳🇿",
    unicode: "U+1F1F3 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/NZ.svg",
  },
  OM: {
    name: "Oman",
    code: "OM",
    emoji: "🇴🇲",
    unicode: "U+1F1F4 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/OM.svg",
  },
  PA: {
    name: "Panama",
    code: "PA",
    emoji: "🇵🇦",
    unicode: "U+1F1F5 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PA.svg",
  },
  PE: {
    name: "Peru",
    code: "PE",
    emoji: "🇵🇪",
    unicode: "U+1F1F5 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PE.svg",
  },
  PF: {
    name: "French Polynesia",
    code: "PF",
    emoji: "🇵🇫",
    unicode: "U+1F1F5 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PF.svg",
  },
  PG: {
    name: "Papua New Guinea",
    code: "PG",
    emoji: "🇵🇬",
    unicode: "U+1F1F5 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PG.svg",
  },
  PH: {
    name: "Philippines",
    code: "PH",
    emoji: "🇵🇭",
    unicode: "U+1F1F5 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PH.svg",
  },
  PK: {
    name: "Pakistan",
    code: "PK",
    emoji: "🇵🇰",
    unicode: "U+1F1F5 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PK.svg",
  },

  PM: {
    name: "St. Pierre & Miquelon",
    code: "PM",
    emoji: "🇵🇲",
    unicode: "U+1F1F5 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PM.svg",
  },
  PN: {
    name: "Pitcairn Islands",
    code: "PN",
    emoji: "🇵🇳",
    unicode: "U+1F1F5 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PN.svg",
  },
  PL: {
    name: "Poland",
    code: "PL",
    emoji: "🇵🇱",
    unicode: "U+1F1F5 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PL.svg",
  },
  PR: {
    name: "Puerto Rico",
    code: "PR",
    emoji: "🇵🇷",
    unicode: "U+1F1F5 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PR.svg",
  },
  PS: {
    name: "Palestinian Territories",
    code: "PS",
    emoji: "🇵🇸",
    unicode: "U+1F1F5 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PS.svg",
  },
  PT: {
    name: "Portugal",
    code: "PT",
    emoji: "🇵🇹",
    unicode: "U+1F1F5 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PT.svg",
  },
  PW: {
    name: "Palau",
    code: "PW",
    emoji: "🇵🇼",
    unicode: "U+1F1F5 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PW.svg",
  },
  PY: {
    name: "Paraguay",
    code: "PY",
    emoji: "🇵🇾",
    unicode: "U+1F1F5 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/PY.svg",
  },
  QA: {
    name: "Qatar",
    code: "QA",
    emoji: "🇶🇦",
    unicode: "U+1F1F6 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/QA.svg",
  },
  RE: {
    name: "Réunion",
    code: "RE",
    emoji: "🇷🇪",
    unicode: "U+1F1F7 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/RE.svg",
  },
  RO: {
    name: "Romania",
    code: "RO",
    emoji: "🇷🇴",
    unicode: "U+1F1F7 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/RO.svg",
  },
  RS: {
    name: "Serbia",
    code: "RS",
    emoji: "🇷🇸",
    unicode: "U+1F1F7 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/RS.svg",
  },
  RU: {
    name: "Russia",
    code: "RU",
    emoji: "🇷🇺",
    unicode: "U+1F1F7 U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/RU.svg",
  },
  RW: {
    name: "Rwanda",
    code: "RW",
    emoji: "🇷🇼",
    unicode: "U+1F1F7 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/RW.svg",
  },
  SA: {
    name: "Saudi Arabia",
    code: "SA",
    emoji: "🇸🇦",
    unicode: "U+1F1F8 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SA.svg",
  },
  SB: {
    name: "Solomon Islands",
    code: "SB",
    emoji: "🇸🇧",
    unicode: "U+1F1F8 U+1F1E7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SB.svg",
  },
  SC: {
    name: "Seychelles",
    code: "SC",
    emoji: "🇸🇨",
    unicode: "U+1F1F8 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SC.svg",
  },
  SD: {
    name: "Sudan",
    code: "SD",
    emoji: "🇸🇩",
    unicode: "U+1F1F8 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SD.svg",
  },
  SE: {
    name: "Sweden",
    code: "SE",
    emoji: "🇸🇪",
    unicode: "U+1F1F8 U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SE.svg",
  },
  SG: {
    name: "Singapore",
    code: "SG",
    emoji: "🇸🇬",
    unicode: "U+1F1F8 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SG.svg",
  },
  SH: {
    name: "St. Helena",
    code: "SH",
    emoji: "🇸🇭",
    unicode: "U+1F1F8 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SH.svg",
  },
  SI: {
    name: "Slovenia",
    code: "SI",
    emoji: "🇸🇮",
    unicode: "U+1F1F8 U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SI.svg",
  },
  SJ: {
    name: "Svalbard & Jan Mayen",
    code: "SJ",
    emoji: "🇸🇯",
    unicode: "U+1F1F8 U+1F1EF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SJ.svg",
  },
  SK: {
    name: "Slovakia",
    code: "SK",
    emoji: "🇸🇰",
    unicode: "U+1F1F8 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SK.svg",
  },
  SL: {
    name: "Sierra Leone",
    code: "SL",
    emoji: "🇸🇱",
    unicode: "U+1F1F8 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SL.svg",
  },
  SM: {
    name: "San Marino",
    code: "SM",
    emoji: "🇸🇲",
    unicode: "U+1F1F8 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SM.svg",
  },
  SN: {
    name: "Senegal",
    code: "SN",
    emoji: "🇸🇳",
    unicode: "U+1F1F8 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SN.svg",
  },
  SO: {
    name: "Somalia",
    code: "SO",
    emoji: "🇸🇴",
    unicode: "U+1F1F8 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SO.svg",
  },
  SR: {
    name: "Suriname",
    code: "SR",
    emoji: "🇸🇷",
    unicode: "U+1F1F8 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SR.svg",
  },
  SS: {
    name: "South Sudan",
    code: "SS",
    emoji: "🇸🇸",
    unicode: "U+1F1F8 U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SS.svg",
  },
  ST: {
    name: "São Tomé & Príncipe",
    code: "ST",
    emoji: "🇸🇹",
    unicode: "U+1F1F8 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ST.svg",
  },
  SV: {
    name: "El Salvador",
    code: "SV",
    emoji: "🇸🇻",
    unicode: "U+1F1F8 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SV.svg",
  },
  SX: {
    name: "Sint Maarten",
    code: "SX",
    emoji: "🇸🇽",
    unicode: "U+1F1F8 U+1F1FD",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SX.svg",
  },
  SY: {
    name: "Syria",
    code: "SY",
    emoji: "🇸🇾",
    unicode: "U+1F1F8 U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SY.svg",
  },
  SZ: {
    name: "Eswatini",
    code: "SZ",
    emoji: "🇸🇿",
    unicode: "U+1F1F8 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SZ.svg",
  },
  TA: {
    name: "Tristan da Cunha",
    code: "TA",
    emoji: "🇹🇦",
    unicode: "U+1F1F9 U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TA.svg",
  },
  TC: {
    name: "Turks & Caicos Islands",
    code: "TC",
    emoji: "🇹🇨",
    unicode: "U+1F1F9 U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TC.svg",
  },
  TD: {
    name: "Chad",
    code: "TD",
    emoji: "🇹🇩",
    unicode: "U+1F1F9 U+1F1E9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TD.svg",
  },
  TF: {
    name: "French Southern Territories",
    code: "TF",
    emoji: "🇹🇫",
    unicode: "U+1F1F9 U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TF.svg",
  },
  TG: {
    name: "Togo",
    code: "TG",
    emoji: "🇹🇬",
    unicode: "U+1F1F9 U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TG.svg",
  },
  TH: {
    name: "Thailand",
    code: "TH",
    emoji: "🇹🇭",
    unicode: "U+1F1F9 U+1F1ED",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TH.svg",
  },
  TJ: {
    name: "Tajikistan",
    code: "TJ",
    emoji: "🇹🇯",
    unicode: "U+1F1F9 U+1F1EF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TJ.svg",
  },
  TK: {
    name: "Tokelau",
    code: "TK",
    emoji: "🇹🇰",
    unicode: "U+1F1F9 U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TK.svg",
  },
  TL: {
    name: "Timor-Leste",
    code: "TL",
    emoji: "🇹🇱",
    unicode: "U+1F1F9 U+1F1F1",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TL.svg",
  },
  TM: {
    name: "Turkmenistan",
    code: "TM",
    emoji: "🇹🇲",
    unicode: "U+1F1F9 U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TM.svg",
  },
  TN: {
    name: "Tunisia",
    code: "TN",
    emoji: "🇹🇳",
    unicode: "U+1F1F9 U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TN.svg",
  },
  TO: {
    name: "Tonga",
    code: "TO",
    emoji: "🇹🇴",
    unicode: "U+1F1F9 U+1F1F4",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TO.svg",
  },
  TR: {
    name: "Turkey",
    code: "TR",
    emoji: "🇹🇷",
    unicode: "U+1F1F9 U+1F1F7",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TR.svg",
  },
  TT: {
    name: "Trinidad & Tobago",
    code: "TT",
    emoji: "🇹🇹",
    unicode: "U+1F1F9 U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TT.svg",
  },
  TV: {
    name: "Tuvalu",
    code: "TV",
    emoji: "🇹🇻",
    unicode: "U+1F1F9 U+1F1FB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TV.svg",
  },
  TW: {
    name: "Taiwan",
    code: "TW",
    emoji: "🇹🇼",
    unicode: "U+1F1F9 U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TW.svg",
  },
  TZ: {
    name: "Tanzania",
    code: "TZ",
    emoji: "🇹🇿",
    unicode: "U+1F1F9 U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/TZ.svg",
  },
  UA: {
    name: "Ukraine",
    code: "UA",
    emoji: "🇺🇦",
    unicode: "U+1F1FA U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UA.svg",
  },
  UG: {
    name: "Uganda",
    code: "UG",
    emoji: "🇺🇬",
    unicode: "U+1F1FA U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UG.svg",
  },
  UM: {
    name: "U.S. Outlying Islands",
    code: "UM",
    emoji: "🇺🇲",
    unicode: "U+1F1FA U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UM.svg",
  },
  UN: {
    name: "United Nations",
    code: "UN",
    emoji: "🇺🇳",
    unicode: "U+1F1FA U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UN.svg",
  },
  US: {
    name: "United States",
    emoji: "🇺🇸",
    unicode: "U+1F1FA U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/US.svg",
  },
  UY: {
    name: "Uruguay",
    code: "UY",
    emoji: "🇺🇾",
    unicode: "U+1F1FA U+1F1FE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UY.svg",
  },
  UZ: {
    name: "Uzbekistan",
    code: "UZ",
    emoji: "🇺🇿",
    unicode: "U+1F1FA U+1F1FF",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/UZ.svg",
  },
  VA: {
    name: "Vatican City",
    code: "VA",
    emoji: "🇻🇦",
    unicode: "U+1F1FB U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VA.svg",
  },
  VC: {
    name: "St. Vincent & Grenadines",
    code: "VC",
    emoji: "🇻🇨",
    unicode: "U+1F1FB U+1F1E8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VC.svg",
  },
  VE: {
    name: "Venezuela",
    code: "VE",
    emoji: "🇻🇪",
    unicode: "U+1F1FB U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VE.svg",
  },
  VG: {
    name: "British Virgin Islands",
    code: "VG",
    emoji: "🇻🇬",
    unicode: "U+1F1FB U+1F1EC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VG.svg",
  },
  VI: {
    name: "U.S. Virgin Islands",
    code: "VI",
    emoji: "🇻🇮",
    unicode: "U+1F1FB U+1F1EE",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VI.svg",
  },
  VN: {
    name: "Vietnam",
    code: "VN",
    emoji: "🇻🇳",
    unicode: "U+1F1FB U+1F1F3",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VN.svg",
  },
  VU: {
    name: "Vanuatu",
    code: "VU",
    emoji: "🇻🇺",
    unicode: "U+1F1FB U+1F1FA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/VU.svg",
  },
  "GB-WLS": {
    name: "Wales",
    code: "GB-WLS",
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    unicode: "U+1F3F4 U+E0067 U+E0062 U+E0077 U+E006C U+E0073 U+E007F",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/GB-WLS.svg",
  },
  WF: {
    name: "Wallis & Futuna",
    code: "WF",
    emoji: "🇼🇫",
    unicode: "U+1F1FC U+1F1EB",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/WF.svg",
  },
  WS: {
    name: "Samoa",
    code: "WS",
    emoji: "🇼🇸",
    unicode: "U+1F1FC U+1F1F8",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/WS.svg",
  },
  XK: {
    name: "Kosovo",
    code: "XK",
    emoji: "🇽🇰",
    unicode: "U+1F1FD U+1F1F0",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/XK.svg",
  },
  YE: {
    name: "Yemen",
    code: "YE",
    emoji: "🇾🇪",
    unicode: "U+1F1FE U+1F1EA",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/YE.svg",
  },
  YT: {
    name: "Mayotte",
    code: "YT",
    emoji: "🇾🇹",
    unicode: "U+1F1FE U+1F1F9",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/YT.svg",
  },
  ZA: {
    name: "South Africa",
    code: "ZA",
    emoji: "🇿🇦",
    unicode: "U+1F1FF U+1F1E6",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ZA.svg",
  },
  ZM: {
    name: "Zambia",
    code: "ZM",
    emoji: "🇿🇲",
    unicode: "U+1F1FF U+1F1F2",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ZM.svg",
  },
  ZW: {
    name: "Zimbabwe",
    code: "ZW",
    emoji: "🇿🇼",
    unicode: "U+1F1FF U+1F1FC",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/ZW.svg",
  },

  SCOTLAND: {
    name: "Scotland",
    code: "SCOTLAND",
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    unicode: "U+1F3F4 U+E0067 U+E0062 U+E0073 U+E0063 U+E0074 U+E007F",
    image: "https://d1fh34r1lqg2ii.cloudfront.net/countries/SCOTLAND.svg",
  },
  GLOBE_EUROPE_AFRICA: {
    name: "Europe/Africa",
    image:
      "https://d1fh34r1lqg2ii.cloudfront.net/countries/Europe-Africa-Globe.svg",
  },
};

export default flags;
